var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-big-button-bar"},_vm._l((_vm.items),function(item,index){return _c('div',{key:index,class:{
      'breakdance-big-button-bar-button': true,
      'breakdance-big-button-bar-button-active': _vm.activeButton[index]
    },on:{"click":function($event){return _vm.setValue(item.value)}}},[(item.icon)?_c('Icon',{staticClass:"mb-2",attrs:{"icon":item.icon || 'SquareIcon',"size":"18"}}):_vm._e(),_c('span',{staticClass:"breakdance-big-button-bar-button-text"},[_vm._v(" "+_vm._s(item.text)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }